<template>
  <div class="user-content-section">
    <div class="page-sub-title user-sub-title" v-if="cardList">
      <h2>
        <i class="fa-title"></i>
        <div>{{ $t("my_cards") }}</div>
      </h2>
    </div>
    <div class="cart-login" style="margin-bottom: 60px" v-if="cardList">
      <div class="social-row">
        <div
          class="card-social-ref"
          v-for="(item, index) in cardList"
          :key="index"
        >
          <div class="card-my">
            <i
              @click="((deleteId = item.id), (deletePopup = true))"
              class="courses-del-desires js-popup-desires fa-close"
            ></i>
            <img
              class="card__text-logo"
              src="../../assets/images/textlogo.svg"
              alt=""
            />
            <img
              class="card__logo"
              src="../../assets/images/logo-circle.svg"
              alt=""
            />
            <img class="chip" src="../../assets/images/chip.svg" alt="" />
            <div class="card-social__content">
              <p class="num">{{ item.masked16.match(/.{1,4}/g).join(" ") }}</p>
              <p>{{ item.expire }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-sub-title user-sub-title">
      <h2>
        <i class="fa-title"></i>
        <div>{{ $t("add_new_card") }}</div>
      </h2>
    </div>
    <div class="cart-login">
      <div class="social-row">
        <div class="cart-social-ref">
          <form
            v-if="!card"
            class="user-form user-form-password"
            @submit.prevent="addMyCard"
          >
            <div class="user-form-group">
              <input
                :class="{
                  invalid:
                    (!$v.num.required && $v.num.$dirty) ||
                    (!$v.num.minLength && $v.num.$dirty),
                }"
                type="text"
                v-maska="'#### #### #### ####'"
                inputmode="number"
                v-model="num"
                class="user-profile-input"
                :placeholder="$t('card_number_placeholder')"
              />
              <div class="error" v-if="!$v.num.required && $v.num.$dirty">
                <div>{{ $t("card_number") }}</div>
              </div>
              <div class="error" v-if="!$v.num.minLength && $v.num.$dirty">
                <div>{{ $t("card_number_error") }}</div>
              </div>
            </div>
            <div class="user-form-group">
              <input
                :class="{
                  invalid:
                    (!$v.expire.required && $v.expire.$dirty) ||
                    (!$v.expire.minLength && $v.expire.$dirty),
                }"
                type="text"
                v-maska="'##/##'"
                v-model="expire"
                class="user-profile-input"
                :placeholder="$t('card_expiry_placeholder')"
              />
              <div class="error" v-if="!$v.expire.required && $v.expire.$dirty">
                <div>{{ $t("card_expiry") }}</div>
              </div>
              <div
                class="error"
                v-if="!$v.expire.minLength && $v.expire.$dirty"
              >
                <div>{{ $t("card_expiry_error") }}</div>
              </div>
            </div>
            <label class="user-sub">
              <input type="submit" /><span>{{ $t("verify") }}</span>
            </label>
          </form>
          <form
            v-else
            class="user-form user-form-password"
            @submit.prevent="addMyCard"
          >
            <div class="user-form-group ext" v-cyr2lat="$store.getters.lang">
              {{ $t("sms_code_sent") }} <br />
              {{ $t("sms_code_sent_to", { phone: card.card.phone }) }}
            </div>
            <div class="user-form-group">
              <input
                :class="{
                  invalid:
                    (!$v.code.required && $v.code.$dirty) ||
                    (!$v.code.minLength && $v.code.$dirty),
                }"
                type="text"
                v-maska="'######'"
                inputmode="number"
                v-model="code"
                class="user-profile-input"
                :placeholder="$t('code_input_placeholder')"
              />
              <div class="error" v-if="!$v.code.required && $v.code.$dirty">
                <div>{{ $t("enter_code") }}</div>
              </div>
              <div class="error" v-if="!$v.code.minLength && $v.code.$dirty">
                <div>{{ $t("code_error") }}</div>
              </div>
            </div>

            <label class="user-sub">
              <input type="submit" />
              <div>{{ $t("verify") }}</div>
            </label>
          </form>
        </div>
        <div class="cart-social-ref">
          <div class="card-my">
            <img
              class="card__text-logo"
              src="../../assets/images/textlogo.svg"
              alt=""
            />
            <img
              class="card__logo"
              src="../../assets/images/logo-circle.svg"
              alt=""
            />
            <img class="chip" src="../../assets/images/chip.svg" alt="" />
            <div class="card-social__content">
              <p class="num">{{ num || "#### #### #### ###" }}</p>
              <p>{{ expire || "##/##" }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DeleteCoursePopup
      :deleteEventText="$t('delete_card_confirm')"
      @close="deletePopup = false"
      :delete-event="true"
      @delete="deleteCard(deleteId)"
      v-if="deletePopup"
    />
  </div>
</template>

<script>
import { minLength, required } from "vuelidate/lib/validators";
import DeleteCoursePopup from "@/components/DeleteCoursePopup";

export default {
  title: "Karta raqamlarim",

  data() {
    return {
      loc: document.location.origin,
      num: "",
      expire: "",
      code: "",
      deleteId: null,
      deletePopup: false,
    };
  },
  validations: {
    num: {
      required,
      minLength: minLength(19),
    },
    expire: {
      required,
      minLength: minLength(5),
    },
    code: {
      required,
      minLength: minLength(6),
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUserCredentials;
    },
    card() {
      return this.$store.getters.getMyCard;
    },
    cardList() {
      return this.$store.getters.getMyCardList;
    },
  },
  async mounted() {
    await this.$store.dispatch("listMyCard");
  },
  methods: {
    async addMyCard() {
      if (!this.card) {
        this.$v.num.$touch();
        this.$v.expire.$touch();
        if (this.$v.num.$invalid && this.$v.expire.$invalid) {
          return;
        }
        let data = {
          number: this.num.replaceAll(" ", ""),
          expire: this.expire,
        };
        await this.$store.dispatch("addMyCard", data);
      } else {
        this.$v.code.$touch();
        if (this.$v.code.$invalid) {
          return;
        }
        let data = {
          sms: this.code,
          phone: this.card.card.phone,
          token: this.card.card.token,
        };
        await this.$store.dispatch("verifyMyCard", data);
        this.$v.$reset();
      }
      this.code = "";
      this.num = "";
      this.expire = "";
    },
    async deleteCard(id) {
      this.deleteId = null;
      this.deletePopup = false;
      await this.$store.dispatch("deleteMyCard", id);
      await this.$store.dispatch("listMyCard");
    },
  },
  components: {
    DeleteCoursePopup,
  },
};
</script>
